<template>
  <div id="data-page" class="container">
    <h5 class="mt-3">マイデータ</h5>
      <div v-if="docs.length > 0 || loadable">
        <div class="row">
          <div v-for="(doc, idx) in docs" class="col-lg-4 col-md-6" :key="idx">
            <div class="card mt-3 pb-2 shadow-sm">
              <div class="container">
                <div class="mt-3">
                  <span class="h5">{{ doc.gameInfo.matchName }}</span>
                  <span v-if="doc.isProMode" class="title-font text-primary float-right">
                    <strong>pro</strong>
                  </span>
                </div>
                <div class="text-center mt-5">
                  {{ doc.gameInfo.player1Name }}
                  <span class="h2 m-4 title-font">
                    {{ doc.gameInfo.player1Game }} - {{ doc.gameInfo.player2Game }}
                  </span>
                  {{ doc.gameInfo.player2Name }}
                </div>
                <b-button variant="outline-secondary"
                  class="mt-5 btn-block mw-330 mx-auto" @click="setDocId(doc.id)">
                  分析画面へ
                </b-button>
                <div class="mt-3">
                  <span class="text-muted">{{ convertDate(doc.createDate) }}</span>
                  <div class="float-right h5" v-if="doc.gameInfo.linkShareFlg">
                    <span class="mr-2">
                      <a :href="createSnsUrl(doc.id)" target="_blank">
                        <font-awesome-icon :icon='["fab", "twitter"]' />
                      </a>
                    </span>
                    <span class="mr-2" @click="execCopy(createUrl(doc.id))">
                      <font-awesome-icon icon="copy" />
                    </span>
                  </div>
                  <div class="float-right" v-else><span class="mr-2 text-muted">非公開</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="mt-5 text-center">
        保存されているデータが見つかりません。
    </div>
    <div class="mt-5 text-center">
      <b-button variant="outline-secondary" v-if="loadable" @click="getData()">
        もっと見る
      </b-button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/firestore';
import { mapActions, mapGetters } from 'vuex';
import utils from '@/lib/utils';

export default {
  name: 'data-page',
  data() {
    return {
      docs: [],
      loadable: true,
      isLoading: false,
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll);
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
    this.getData();
  },
  computed: {
    ...mapGetters([
      'user',
      'app',
    ]),
  },
  methods: {
    ...mapActions([
      'storeIsLoading',
      'SignOut',
      'setGameData',
      'setGameDataOption',
    ]),
    getData() {
      // isLoadingがfalseのとき（処理中ではない) かつ loadable（まだ読み込むデータがあった場合）に読み込み処理を実行
      if (!this.isLoading && this.loadable) {
        // 処理実行前に処理中フラグを立てる
        const limitCnt = 12;
        this.isLoading = true;
        this.storeIsLoading(true);
        const db = firebase.firestore();
        const dt = new Date();
        const lastDate = this.docs.length === 0 ?
          new Date(dt.setHours(dt.getHours() + 1)) : this.docs[this.docs.length - 1].createDate;
        db.collection('games')
          .where('author', '==', this.user.uid)
          .where('status', '==', 10)
          .orderBy('createDate', 'desc')
          .startAfter(lastDate)
          .limit(limitCnt)
          .get()
          .then((querySnapshot) => {
            this.loadable = querySnapshot.size >= limitCnt;
            querySnapshot.forEach((doc) => {
              this.docs.push({
                id: doc.id,
                gameInfo: doc.data().gameInfo,
                createDate: doc.data().createDate,
                isProMode: doc.data().isProMode,
              });
            });
          })
          .catch((error) => {
            if (error.message === 'Missing or insufficient permissions.') {
              this.SignOut();
              this.$router.push('/');
              alert('タイムアウトしました。再度ログインしてからやり直してください。');
            }
          })
          .finally(() => {
            this.isLoading = false;
            this.storeIsLoading(false);
          });
      }
    },
    setDocId(docId) {
      this.storeIsLoading(true);
      this.firestoreGet(docId)
        .then(() => {
          this.$router.push('/analyze');
        })
        .catch(() => {
          alert('データの読み込みに失敗しました。');
        })
        .finally(() => {
          this.storeIsLoading(false);
        });
    },
    async firestoreGet(docId) {
      const db = firebase.firestore();
      const doc = await db.collection('games').doc(docId)
        .get();
      if (doc.exists) {
        if (doc.data().isProMode) {
          const docOption = await db.collection('games').doc(docId).collection('option').doc('hitsList')
            .get();
          this.setGameDataOption({ docId, game: doc.data(), option: docOption.data() });
        } else {
          this.setGameData({ docId, data: doc.data() });
        }
      }
    },
    scroll() {
      if (!this.isLoading) {
        const dataPage = document.getElementById('data-page');
        if (dataPage.getBoundingClientRect().bottom + 200 < window.innerHeight) {
          this.getData();
        }
      }
    },
    convertDate(date) {
      return utils.dateFormat(date.toDate());
    },
    createUrl(docId) {
      return utils.createUrl(docId);
    },
    createSnsUrl(docId) {
      return utils.createSnsUrl(docId);
    },
    execCopy(string) {
      return utils.execCopy(string);
    },
  },
};

</script>

<style scoped>

#data-page{
  min-height: 700px;
}

.title-font{
  font-family: 'Orbitron', sans-serif;
}

.mw-330{
  max-width: 330px;
}
</style>



// WEBPACK FOOTER //
// src/views/DataPage.vue